/* eslint-disable react/no-unstable-nested-components */
import React, { useState } from 'react';
import { Box } from '@chakra-ui/react';
import { ArrowSquareOut, ChartBar } from 'phosphor-react';
import { RowActionButton } from '../../components/buttons/RowActionButton';
import { DataGrid } from '../../components/datagrid';
import { SearchFilter } from '../../components/inputs/filters/search';
import { PageTitle } from '../../components/PageTitle';
import { useFetch } from '../../hooks/useFetch';
import { getCellStatus } from '../../utils/FormatFunctions';
import { useAuth } from '../../providers/auth';
import { usePageTracking } from '../../hooks/usePageTracking';
import { useAnalytics } from '../../hooks/useAnalytics';
import { AnalyticsModal } from '../../components/analytics';
import { useActionToast } from '../../services/actionToast';

export function ExtraMaterialsPage() {
  usePageTracking('extra_materials_list');

  const [selectedMaterial, setSelectedMaterial] = useState<number | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const baseApiUrl = '/v1/admin';
  const baseUrl = `${baseApiUrl}/extra_materials`;
  const { requestApi, data, loading, error } = useFetch(baseUrl);
  const { user } = useAuth();
  const { trackMaterialView, trackMaterialDownload } = useAnalytics();
  const toast = useActionToast();

  // Analytics será carregado apenas quando o usuário clicar no ícone de estatísticas
  // através do AnalyticsModal

  const columns = [
    { name: 'id', label: 'Id' },
    { name: 'name', label: 'Nome' },
    { name: 'user_type', label: 'Material para' },
    { name: 'institution.name', label: 'Instituição' },
    { name: 'status', label: 'Status' },
  ];
  const groupIds = user?.group?.id;

  const handleMaterialOpen = (rowItem: any) => {
    const resourceUrl = rowItem.type === 'MIDIA' ? rowItem.file?.original : rowItem.link;
    if (!resourceUrl) {
      toast({
        status: 'error',
        title: 'Material não aberto',
        description: 'O arquivo ou link deste material não está disponível.',
      });
      return;
    }
    const openedWindow = window.open(resourceUrl, '_blank');
    if (openedWindow) {
      trackMaterialView(rowItem.id);
      if (rowItem.is_downloadable) trackMaterialDownload(rowItem.id);
    }
    toast({
      status: openedWindow ? 'success' : 'error',
      title: openedWindow ? 'Material aberto' : 'Material não aberto',
      description: openedWindow
        ? 'O material foi aberto em uma nova guia.'
        : 'Permita novas janelas no navegador e tente novamente.',
    });
  };

  const handleOpenModal = (materialId: number) => {
    setSelectedMaterial(materialId);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedMaterial(null);
  };

  return (
    <Box>
      <PageTitle description="Publique materiais complementares para as instituições.">
        Materiais Extras
      </PageTitle>

      <DataGrid
        columns={columns}
        rows={data?.data}
        requestApi={requestApi}
        error={error}
        baseUrl={baseUrl}
        data={data}
        hasCreate={groupIds !== 7 && groupIds !== 6 && groupIds !== 3}
        loading={loading}
        rowActions={{
          show: groupIds === 3,
          edit: groupIds !== 7 && groupIds !== 6 && groupIds !== 3,
          delete: groupIds !== 6 && groupIds !== 3 && groupIds !== 5,
        }}
        rowExtraActions={(rowItem: any) => (
          <>
            <RowActionButton
              label={`Abrir material ${rowItem.name}`}
              icon={<ArrowSquareOut size={16} />}
              onClick={() => handleMaterialOpen(rowItem)}
            />
            <RowActionButton
              label="Estatísticas"
              icon={<ChartBar size={16} />}
              onClick={() => handleOpenModal(rowItem.id)}
            />
          </>
        )}
        formatColum={[
          {
            field: 'status',
            formatField: getCellStatus,
          },
        ]}
        headerFilters={[
          {
            name: 'search',
            filterComponent: SearchFilter,
          },
        ]}
      />

      {/* Modal de Estatísticas */}
      <AnalyticsModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        materialId={selectedMaterial || undefined}
        type="material"
      />
    </Box>
  );
}
